export default __webpack_public_path__ + "static/media/cat_cry.fdd923f1.jpeg";